module.exports = __webpack_public_path__ + "assets/fe69f7fce8fc4e973a17eb164f6a7f45.png";